import styled, { css } from 'styled-components';

export const HeaderWrapper = styled.div<{ $lightHeader?: boolean }>(
  ({ theme, $lightHeader }) => css`
    position: sticky;
    top: 0;
    z-index: ${theme.zi.header};
    padding: ${theme.sz.s4};
    width: 100%;
    display: flex;
    align-items: center;
    background-color: ${$lightHeader ? theme.co.neutral99 : theme.co.secondary20};
  `,
);

export const HeaderWrapperInner = styled.nav<{ $minimalHeader?: boolean }>(
  ({ $minimalHeader }) => css`
    width: 100%;
    display: flex;
    justify-content: space-between;
    flex: ${$minimalHeader ? 0 : 1};
    align-items: center;
  `,
);

export const HeaderInner = styled.nav`
  display: flex;
  align-items: baseline;
`;

export const ChildrenWrapper = styled.div<{ $minimalHeader?: boolean }>(
  ({ theme, $minimalHeader }) => css`
    flex: 1;
    margin-right: ${theme.sz.s8};
    display: flex;
    justify-content: ${$minimalHeader ? 'flex-start' : 'flex-end'};
    align-items: center;
    height: ${theme.sz.s10};

    @media (max-width: ${theme.sz.maxMobileBreakpoint}) {
      flex: 1;
      margin-right: ${$minimalHeader ? 0 : theme.sz.s8};
    }
  `,
);

export const BetaTag = styled.a(
  ({ theme }) => css`
    display: block;
    text-decoration: none;
    margin: 0 ${theme.sz.s8} 0;
    white-space: nowrap;
    color: ${theme.co.neutral0};
    font-weight: ${theme.DEPRECATED_ty.bold};

    @media (max-width: ${theme.sz.sm}) {
      display: none;
    }

    &:any-link:hover {
      color: ${theme.co.primary60};
    }
  `,
);

export const StreakWrapper = styled.button(
  ({ theme }) => css`
    background: none;
    border: none;
    padding: unset;
    cursor: pointer;
    margin-right: ${theme.sz.s6};

    @media (max-width: ${theme.sz.minMobileBreakpoint}) {
      margin-right: ${theme.sz.s4};
    }
  `,
);

export const IconWrapper = styled.a(
  ({ theme }) => css`
    cursor: pointer;
    text-decoration: none;
    color: ${theme.co.neutral0};

    &:hover {
      color: ${theme.co.neutral40};
    }

    svg {
      height: ${theme.sz.s6};
      width: ${theme.sz.s6};
    }

    margin-right: ${theme.sz.s6};

    @media (max-width: ${theme.sz.minMobileBreakpoint}) {
      margin-right: ${theme.sz.s4};
    }
  `,
);
